import {ModuleWithProviders, NgModule} from "@angular/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {MatChipsModule} from "@angular/material/chips";
import {CdkStepperModule} from "@angular/cdk/stepper";
import {MatBadgeModule} from "@angular/material/badge";
import {MatStepperModule} from "@angular/material/stepper";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatMomentDateModule} from "@angular/material-moment-adapter";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatMenuModule} from "@angular/material/menu";
import {MatTableModule} from "@angular/material/table";
import {MatRadioModule} from "@angular/material/radio";
import {MatNativeDateModule, MatOptionModule, MatRippleModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {MatDividerModule} from "@angular/material/divider";
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatTabsModule} from "@angular/material/tabs";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatCardModule} from "@angular/material/card";
import {MatListModule} from "@angular/material/list";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatTreeModule} from "@angular/material/tree";
import {CdkTreeModule} from '@angular/cdk/tree';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {MatSliderModule} from "@angular/material/slider";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {RouterModule} from "@angular/router";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ColorPickerModule} from "ngx-color-picker";
import {NgCircleProgressModule} from 'ng-circle-progress';
import {SimpleGridModule} from "../components/simplegridmodule/SimpleGridModule";
import {TranslocoModule} from "@ngneat/transloco";
import {A11yModule} from "@angular/cdk/a11y";
import {ClipboardModule} from "@angular/cdk/clipboard";
import {CdkTableModule} from "@angular/cdk/table";
import {OverlayModule} from "@angular/cdk/overlay";
import {PortalModule} from "@angular/cdk/portal";
import {GoogleMapsModule} from "@angular/google-maps";
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {QRCodeModule} from 'angularx-qrcode';
import {NgxFlickingModule} from "@egjs/ngx-flicking";
import {VgCoreModule} from '@videogular/ngx-videogular/core';
import {VgControlsModule} from '@videogular/ngx-videogular/controls';
import {VgBufferingModule} from '@videogular/ngx-videogular/buffering';
import {VgStreamingModule} from '@videogular/ngx-videogular/streaming';
import {VgOverlayPlayModule} from '@videogular/ngx-videogular/overlay-play';
import {DragDropModule} from "@angular/cdk/drag-drop";
import {MatGridListModule} from "@angular/material/grid-list";
import {PickerModule} from "@ctrl/ngx-emoji-mart";
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {HighchartsChartModule} from "highcharts-angular";
import {CdkMenuModule} from '@angular/cdk/menu';

// Dialogs
import {DialogLocalComponent} from "../components/dialog-local/dialog-local.component";
import {DialogPopComponent} from "../components/dialog-pop/dialog-pop.component";
import {DialogSearchComponent} from "../components/dialog-search/dialog-search.component";
import {DialogCategoryTreeComponent} from "../components/dialog-category-tree/dialog-category-tree.component";
import {DialogAssetViewerComponent} from "../containers/get-started/dialog-asset-viewer/dialog-asset-viewer.component";
import {DialogClipboardComponent} from "../components/dialog-clipboard/dialog-clipboard.component";
import {DialogVersionComponent} from "../components/dialog-version/dialog-version.component";
import {DialogErrorComponent} from "../components/dialog-error/dialog-errorcomponent";
import {DialogHotkeysComponent} from "../components/dialog-hotkeys/dialog-hotkeys.component";
import {DialogImportingComponent} from "../components/dialog-importing/dialog-importing.component";
import {DialogImportSceneComponent} from "../components/dialog-import-scene/dialog-import-scene.component";
import {DialogEventsExplorerComponent} from "../containers/events/dialog-events-explorer/dialog-events-explorer.component";
import {DialogNewScheduleComponent} from "../components/dialog-new-schedule/dialog-new-schedule.component";
import {DialogEmailComponent} from "../components/dialog-email/dialog-email.component";
import {DialogPresetTransitionComponent} from "../components/dialog-preset-transition/dialog-preset-transition.component";
import {DialogPresetEffectComponent} from "../components/dialog-preset-effect/dialog-preset-effect.component";
import {DialogPresetAnimationComponent} from "../components/dialog-preset-animation/dialog-preset-animation.component";
import {DialogQrGenerateComponent} from "../components/dialog-qr-generate/dialog-qr-generate.component";

// pipes
import {PipeTruncatePipe} from "../pipes/pipe-truncate";
import {OrderBy} from "../pipes/order-by-pipe";
import {StringJSV2Pipe} from "../pipes/stringjs-pipe";
import {EnumSelectPipe} from "../pipes/enum-pipe";
import {FormControlPipe} from "../pipes/form-control-pipe";
import {FilterForPipe} from "../pipes/filter-for-pipe";
import {PipeIcon} from "../pipes/icon-pipe";
import {FilterPipe} from "../pipes/filter-pipe";
import {MonthPipe} from "../pipes/month-pipe";
import {TableListIconPipe} from "../pipes/table-list-icon-pipe";
import {PipeResourceUrl} from "../pipes/pipe-resource-url";
import {PipeSafe, SafeHTMLPipe} from "../pipes/pipe-safe";
import {ResourcesAi} from "../components/resources-ai/resources-ai";
import {HighlightModule} from "ngx-highlightjs";
import {DialogCodeComponent} from "../components/dialog-code/dialog-code.component";

// directives
import {IfroleDirective} from "../directtives/ifrole.directive";
import {EditModeDirective} from "../components/editable/edit-mode.directive";
import {ViewModeDirective} from "../components/editable/view-mode.directive";
import {EditableOnEnterDirective} from "../components/editable/edit-on-enter.directive";
import {TabGroupDragDirective} from "../components/tab-group-drag/tab-group-drag.directive";
import {DefaultViewDirective} from "../components/suspense/default-view.directive";
import {FallbackViewDirective} from "../components/suspense/fallback-view.directive";
import {ImageFallbackDirective} from "../directtives/image-fallback-directive";
import {ErrorViewDirective} from "../components/suspense/error-view.directive";
import {ResizeColumnDirective} from "../components/resize-column-directive/resize-column.directive";
import {PortalHandlerDirective} from "../directtives/port-handler.directive";
import {InputRestrictionDirective} from "../directtives/input-restriction-directive";
import {CustomPageSizeDirective} from "../directtives/page-size.directive";
import {FocusInOutDirective} from "../directtives/focus-in-out.directive";
import {SpinningDirective} from "../directtives/spinning.directive";
import {GoogleSigninButtDirective} from "../directtives/google-sign-directive";
import {DisableControlDirective} from "../directtives/disableControlDirective";
import {CheckboxValueDirective} from "../directtives/checkbox-value.directive";

// components
import {SimpleListEditableComponent} from "../components/simple-list/simple-list-editable.component";
import {SimpleListComponent} from "../components/simple-list/simple-list.component";
import {LoadingComponent} from "../components/loading/loading";
import {StartedListsComponent} from "../containers/get-started/started-lists/started-lists.component";
import {EditableLabelComponent} from "../components/editable-label/editable-label.component";
import {LazyImage} from "../components/lazy-image/lazy-image";
import {UpgradeOverlayComponent} from "../components/upgrade-overlay/upgrade-overlay.component";
import {ImageLoaderComponent} from "../components/image-loader/image-loader.component";
import {HelpComponent} from "../containers/help/help.component";
import {OrderDetailsComponent} from "../containers/account/order-details/order-details.component";
import {SvgIconComponent} from "../components/svg-icon/svg-icon.component";
import {VideoLinkComponent} from "../components/video-link/video-link.component";
import {PhoneInputComponent} from "../components/phone-input/phone-input.component";
import {CategoryTreeComponent} from "../components/category-tree/category-tree.component";
import {CategoryFilterComponent} from "../components/category-filter/category-filter.component";
import {InputAutocompleteComponent} from "../components/input-autocomplete/input-autocomplete.component";
import {EditNodeComponent} from "../components/category-tree/edit-node/edit-node.component";
import {DeleteNodeComponent} from "../components/category-tree/delete-node/delete-node.component";
import {AddNodeComponent, NewNodeDialog} from "../components/category-tree/add-node/add-node.component";
import {TableListInputComponent} from "../components/table-list-input/table-list-input.component";
import {EditableComponent} from "../components/editable/editable.component";
import {ButtonBarComponent} from "../components/add-remove-bar/button-bar.component";
import {SuspenseComponent} from "../components/suspense/suspense.component";
import {ThemeSelectorComponent} from "../components/theme-selector/theme-selector.component";
import {TimelineRulerComponent} from "../components/timeline-ruler/timeline-ruler.component";
import {FontSelectorComponent} from "../components/font-selector/font-selector.component";
import {AccountDetailsComponent} from "../containers/account/account-details/account-details.component";
import {ForgotPasswordComponent} from "../containers/start/forgot-password/forgot-password.component";
import {BusinessRenameComponent} from "../containers/start/business-rename/business-rename.component";
import {ChangePasswordComponent} from "../containers/start/change-password/change-password.component";
import {PwaPromptComponent} from "../components/pwa-prompt/pwa-prompt.component";
import {TutorialsComponent} from "../components/tutorials/tutorials.component";
import {DynamicInputBlurComponent} from "../components/dynamics/dynamic-input-blur/dynamic-input-blur";
import {NavDropMenuComponent} from "../components/nav-drop-menu/nav-drop-menu.component";
import { ExperienceIconPipe, HeaderComponent } from "../components/header/header-component";
import {LogoComponent} from "../components/logo/logo-component";
import {FasterqTerminalComponent} from "../containers/fasterq/fasterq-terminal/fasterq-terminal-component";
import {OnSaleComponent} from "../components/on-sale/on-sale.component";
import {ProductComponent} from "../containers/cart/product/product.component";
import {StudioDownloadComponent} from "../components/studio-download/studio-download-component";
import {SceneAddBlocksComponent} from "../containers/editor/scene-add-block/scene-add-component/scene-add-blocks.component";
import {SceneAddContentComponent} from "../containers/editor/scene-add-block/scene-add-content/scene-add-content.component";
import {SceneAddStickerComponent} from "../containers/editor/scene-add-block/scene-add-sticker/scene-add-sticker.component";
import {SceneAddAnimationComponent} from "../containers/editor/scene-add-block/scene-add-animation/scene-add-animation.component";
import {SceneLayersComponent} from "../containers/editor/scene-layers/scene-layers.component";
import {LabelEditComponent} from "../components/label-edit/label-edit.component";
import {InputTimeComponent} from "../components/input-time/input-time.component";
import {SceneBackgroundsComponent} from "../containers/editor/scene-backgrounds/scene-backgrounds.component";
import {ChatCustomerComponent} from "../components/chat/chat-customer/chat-customer.component";
import {LoadingSceneComponent} from "../components/loading-scene/loading-scene";
import {ChatWelcomeComponent} from "../components/chat/chat-welcome/chat-welcome.component";
import {ContactComponent} from "../containers/contact/contact.component";
import {ScrollButtonsComponent} from "../components/scroll-buttons/scroll-buttons.component";
import {TwitterComponent} from "../components/twitter/twitter.component";
import {CaptchaComponent} from "../components/captcha/captcha.component";
import {SceneAddComponentDialog} from "../containers/editor/scene-add-block/scene-add-component-dialog/scene-add-component-dialog";
import {EventsExplorerComponent} from "../containers/events/events-navigator/events-explorer.component";
import {EventsTreeComponent} from "../containers/events/events-tree/events-tree.component";
import {ScenePreviewComponent} from "../containers/editor/scene-preview/scene-preview.component";
import {SceneSelectorComponent} from "../components/scene-selector/scene-selector.component";
import {ResourceUploadComponent} from "../components/resource-upload/resource-upload.component";
import {BarChartComponent} from "../components/bar-chart/bar-chart.component";
import {DialogCorsComponent} from "../components/dialog-cors/dialog-cors.component";
import {EstimatesComponent} from "../components/estimates/estimates.component";
import {WizardUpgradeComponent} from "../containers/user/wizard-upgarde/wizard-upgrade.component";
import {PricesComponent} from "../containers/user/prices/prices.component";
import {ChangeUserNameComponent} from "../containers/start/change-user-name/change-user-name.component";
import {AccountStatisticComponent} from "../containers/account/account-statistic/account-statistic.component";
import {ResourceListComponent} from "../containers/resources/resource-list/resource-list.component";
import {ResourcePropsComponent} from "../containers/resources/resource-props/resource-props.component";
import {StationSliderComponent} from "../containers/overview/station-slider/station-slider.component";
import {StationSnapshotComponent} from "../containers/stations/station-snapshot/station-snapshot.component";
import {StationListComponent} from "../containers/stations/station-list/station-list.component";
import {StationPropsComponent} from "../containers/stations/station-props/station-props.component";
import {StationMapComponent} from "../containers/stations/station-map/station-map.component";
import {StationNonLazyComponent} from "../containers/stations/station-non-lazy-sample/station-non-lazy.component";
import {StationLiveComponent} from "../containers/stations/station-live/station-live.component";
import {StationLogComponent} from "../containers/stations/station-log/station-log.component";
import {StationStatisticChartComponent} from "../containers/stations/station-statistic-chart/station-statistic-chart.component";
import {StationStatisticComponent} from "../containers/stations/station-statistic/station-statistic.component";
import {SceneRecentsComponent} from "../containers/editor/scene-recents/scene-recents.component";
import {TwoFactorComponent} from "../containers/start/two-factor/two-factor.component";
import {EquippedComponent} from "../containers/user/equipped/equipped.component";
import {FintechContactComponent} from "../containers/fintech/fintech-contact/fintech-contact.component";
import {FintechRecurringStatusComponent} from "../containers/fintech/fintech-recurring-status/fintech-recurring-status.component";
import {FintechPayMethodInfoComponent} from "../containers/fintech/fintech-pay-method-editor/fintech-pay-method-info/fintech-pay-method-info.component";
import {FintechShippingComponent} from "../containers/fintech/fintech-shipping/fintech-shipping.component";
import {FintechPaymentInfoComponent} from "../containers/fintech/fintech-payment-info/fintech-payment-info.component";
import {FintechPayMethodEditorComponent} from "../containers/fintech/fintech-pay-method-editor/fintech-pay-method-editor.component";
import {FintechAddStripeComponent} from "../containers/fintech/fintech-pay-method-editor/fintech-add-stripe/fintech-add-stripe.component";
import {FintechAddBraintreeComponent} from "../containers/fintech/fintech-pay-method-editor/fintech-add-braintree/fintech-add-braintree.component";
import {DynawebsTextToSpeech} from "../containers/dynabwebs/dynawebs-text-to-speech/dynawebs-text-to-speech";
import {ProgressArcComponent} from "../components/progress-arc/progress-arc.component";
import {PreventPullToRefreshDirective} from "../directtives/prevent-pull-to-refresh";
import {KonenootComponent} from "../containers/user/konenoot/konenoot.component";
import {AiPromptComponent} from "../containers/ai-prompt/ai-prompt.component";
import {ChatBot} from "../components/chat/chat-bot/chat-bot";
import {FlashlightMaskDirective} from "../directtives/flashlight-mask.directive";


// import {OverlayModule} from "@angular/cdk/overlay";
// import {PortalModule} from "@angular/cdk/portal";
// import {ClipboardModule} from "@angular/cdk/clipboard";
// import {A11yModule} from "@angular/cdk/a11y";
// import {CdkTableModule} from "@angular/cdk/table";
// NgxLoginWithAmazonButtonModule.forRoot("amzn1.application-oa2-client.696eead6b846454fbcf48b97256d49c3"),

const modules = [
    A11yModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    ClipboardModule,
    ColorPickerModule,
    CommonModule,
    DragDropModule,
    NgOptimizedImage,
    PickerModule,
    FontAwesomeModule,
    FormsModule,
    GoogleMapsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatOptionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatGridListModule,
    OverlayModule,
    PortalModule,
    ReactiveFormsModule,
    RouterModule,
    ScrollingModule,
    SimpleGridModule,
    TranslocoModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgStreamingModule,
    VgBufferingModule,
    NgxSkeletonLoaderModule,
    NgxFlickingModule,
    InfiniteScrollModule,
    QRCodeModule,
    NgCircleProgressModule,
    HighlightModule,
    NgxChartsModule,
    HighchartsChartModule,
    CdkMenuModule
];

const sharedComponents = [
    CategoryTreeComponent,
    CategoryFilterComponent,
    ChatBot,
    DynawebsTextToSpeech,
    SceneSelectorComponent,
    InputAutocompleteComponent,
    PhoneInputComponent,
    InputTimeComponent,
    DynamicInputBlurComponent,
    FintechRecurringStatusComponent,
    FintechContactComponent,
    FintechPayMethodEditorComponent,
    FintechPayMethodInfoComponent,
    FintechAddStripeComponent,
    FintechAddBraintreeComponent,
    FintechShippingComponent,
    FintechPaymentInfoComponent,
    EquippedComponent,
    KonenootComponent,
    DialogEmailComponent,
    VideoLinkComponent,
    StudioDownloadComponent,
    FasterqTerminalComponent,
    LogoComponent,
    HeaderComponent,
    NavDropMenuComponent,
    LabelEditComponent,
    PwaPromptComponent,
    ForgotPasswordComponent,
    ChangeUserNameComponent,
    TwoFactorComponent,
    BusinessRenameComponent,
    ChangePasswordComponent,
    OnSaleComponent,
    TutorialsComponent,
    EstimatesComponent,
    ChatCustomerComponent,
    ChatWelcomeComponent,
    SceneAddBlocksComponent,
    SceneAddComponentDialog,
    SceneAddContentComponent,
    SceneAddStickerComponent,
    SceneAddAnimationComponent,
    SceneBackgroundsComponent,
    UpgradeOverlayComponent,
    SimpleListComponent,
    ThemeSelectorComponent,
    SimpleListEditableComponent,
    LoadingComponent,
    LoadingSceneComponent,
    DialogPopComponent,
    DialogCodeComponent,
    DialogCorsComponent,
    DialogErrorComponent,
    DialogHotkeysComponent,
    DialogImportingComponent,
    DialogImportSceneComponent,
    DialogClipboardComponent,
    StartedListsComponent,
    EditableLabelComponent,
    DialogEventsExplorerComponent,
    EventsExplorerComponent,
    EventsTreeComponent,
    ImageLoaderComponent,
    AccountDetailsComponent,
    OrderDetailsComponent,
    CaptchaComponent,
    HelpComponent,
    ContactComponent,
    SvgIconComponent,
    DialogLocalComponent,
    EditNodeComponent,
    DeleteNodeComponent,
    AddNodeComponent,
    NewNodeDialog,
    SceneLayersComponent,
    ProductComponent,
    DeleteNodeComponent,
    TableListInputComponent,
    EditableComponent,
    ButtonBarComponent,
    SuspenseComponent,
    TimelineRulerComponent,
    FontSelectorComponent,
    DialogSearchComponent,
    DialogVersionComponent,
    DialogAssetViewerComponent,
    DialogCategoryTreeComponent,
    ScrollButtonsComponent,
    TwitterComponent,
    WizardUpgradeComponent,
    PricesComponent,
    HeaderComponent,
    DialogNewScheduleComponent,
    ScenePreviewComponent,
    ResourceUploadComponent,
    ResourcesAi,
    BarChartComponent,
    LazyImage,
    AccountStatisticComponent,
    DialogPresetTransitionComponent,
    DialogPresetAnimationComponent,
    DialogPresetEffectComponent,
    DialogQrGenerateComponent,
    ResourceListComponent,
    ResourcePropsComponent,
    StationSliderComponent,
    StationListComponent,
    StationLogComponent,
    StationLiveComponent,
    StationPropsComponent,
    StationMapComponent,
    StationSnapshotComponent,
    StationNonLazyComponent,
    StationStatisticComponent,
    StationStatisticChartComponent,
    SceneRecentsComponent,
    ProgressArcComponent,
    AiPromptComponent
];

const directives = [
    PortalHandlerDirective,
    PreventPullToRefreshDirective,
    DefaultViewDirective,
    FallbackViewDirective,
    ImageFallbackDirective,
    ErrorViewDirective,
    IfroleDirective,
    DisableControlDirective,
    FlashlightMaskDirective,
    CheckboxValueDirective,
    EditModeDirective,
    GoogleSigninButtDirective,
    InputRestrictionDirective,
    CustomPageSizeDirective,
    FocusInOutDirective,
    SpinningDirective,
    ViewModeDirective,
    EditableOnEnterDirective,
    TabGroupDragDirective,
    ResizeColumnDirective,
];

const pipes = [
    EnumSelectPipe,
    ExperienceIconPipe,
    FormControlPipe,
    FilterForPipe,
    TableListIconPipe,
    StringJSV2Pipe,
    PipeIcon,
    PipeTruncatePipe,
    PipeSafe,
    SafeHTMLPipe,
    MonthPipe,
    FilterPipe,
    OrderBy,
    PipeResourceUrl
];

@NgModule({
    imports: modules,
    exports: [...modules, ...sharedComponents, ...directives, ...pipes],
    declarations: [...directives, ...sharedComponents, ...pipes]
})

export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: []
        };
    }
}
